(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chodo-hero-v2"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('chodo-hero-motion'))customElements.define('chodo-hero-motion',class extends HTMLElement{connectedCallback(){this.video=this.querySelector('video');this.button=this.querySelector('button');this.media=matchMedia('(prefers-reduced-motion: reduce)');this.toggle=()=>this.setMotion(!this.running);this.change=()=>this.setMotion(this.dataset.motion==='true'&&!this.media.matches);this.button.addEventListener('click',this.toggle);this.media.addEventListener('change',this.change);this.button.hidden=false;this.change()}setMotion(on){this.running=on;this.toggleAttribute('data-running',on);this.button.textContent=on?this.button.dataset.pause:this.button.dataset.play;this.button.setAttribute('aria-pressed',String(on));if(this.video){if(on)this.video.play().catch(()=>{this.running=false;this.removeAttribute('data-running');this.button.textContent=this.button.dataset.play;this.button.setAttribute('aria-pressed','false')});else this.video.pause()}}disconnectedCallback(){this.video?.pause();this.button?.removeEventListener('click',this.toggle);this.media?.removeEventListener('change',this.change)}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chodo-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('chodo-video')) {
 customElements.define('chodo-video', class extends HTMLElement {
  connectedCallback() {
   this.video = this.querySelector('video'); if (!this.video) return;
   this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
   this.onMotion = () => { if (this.motion.matches) this.video.pause(); };
   this.motion.addEventListener('change', this.onMotion);
   if (!this.motion.matches) this.video.play().catch(() => {});
  }
  disconnectedCallback() { this.motion?.removeEventListener('change', this.onMotion); this.video?.pause(); }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chodo-orte-v2"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('chodo-map'))customElements.define('chodo-map',class extends HTMLElement{connectedCallback(){this.button=this.querySelector('button');this.load=()=>{let url;try{url=new URL(this.dataset.url)}catch{return}if(url.protocol!=='https:')return;const frame=document.createElement('iframe');frame.src=url.href;frame.title=this.dataset.title;frame.loading='lazy';frame.referrerPolicy='no-referrer';this.replaceChildren(frame)};this.button?.addEventListener('click',this.load)}disconnectedCallback(){this.button?.removeEventListener('click',this.load)}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chodo-zutaten-v2"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('chodo-ingredient-strip'))customElements.define('chodo-ingredient-strip',class extends HTMLElement{connectedCallback(){this.strip=this.querySelector('.strip');this.button=this.querySelector('button');this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.running=!this.motion.matches;this.direction=1;this.hover=false;this.button.hidden=false;this.update=()=>{this.button.textContent=this.running?this.button.dataset.pause:this.button.dataset.play;this.button.setAttribute('aria-pressed',String(this.running))};this.toggle=()=>{this.running=!this.running;this.update()};this.enter=()=>this.hover=true;this.leave=()=>this.hover=false;this.reduce=()=>{if(this.motion.matches)this.running=false;this.update()};this.button.addEventListener('click',this.toggle);this.strip.addEventListener('pointerenter',this.enter);this.strip.addEventListener('pointerleave',this.leave);this.strip.addEventListener('focusin',this.enter);this.strip.addEventListener('focusout',this.leave);this.strip.addEventListener('touchstart',this.enter,{passive:true});this.strip.addEventListener('touchend',this.leave,{passive:true});this.motion.addEventListener('change',this.reduce);this.update();this.tick=(now)=>{const dt=Math.min(now-(this.last||now),50);this.last=now;if(this.running&&!this.hover&&!document.hidden){const max=this.strip.scrollWidth-this.strip.clientWidth;if(max>0){if(this.strip.scrollLeft>=max-1)this.direction=-1;if(this.strip.scrollLeft<=0)this.direction=1;this.strip.scrollLeft+=this.direction*dt*.022}}this.frame=requestAnimationFrame(this.tick)};this.frame=requestAnimationFrame(this.tick)}disconnectedCallback(){cancelAnimationFrame(this.frame);this.motion?.removeEventListener('change',this.reduce);this.button?.removeEventListener('click',this.toggle);for(const [ev,fn] of [['pointerenter',this.enter],['pointerleave',this.leave],['focusin',this.enter],['focusout',this.leave],['touchstart',this.enter],['touchend',this.leave]])this.strip?.removeEventListener(ev,fn)}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
